<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ $root.t.navigation.domain_names }}
              </h6>
              <div class="element-box-tp">
                <div class="text-left">
                  <table class="table table-striped table-bordered">
                    <thead>
                    <tr>
                      <th colspan="2">Domain</th>
                      <th>Default</th>
                      <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colspan="2">
                        <input type="text" v-model="newDomain.domain" class="form-control"/>
                      </td>
                      <td colspan="2">
                        <a href="javascript:;" @click="postThisDomain(newDomain)" class="btn btn-primary btn-lg btn-block btn-outline-primary">
                          <i class="icon-plus"></i>
                        </a>
                      </td>
                    </tr>
                    <tr v-for="domain in domains">
                      <td>
                        <input type="text" v-model="domain.domain" class="form-control"/>
                      </td>
                      <td class="w50">
                        <a href="javascript:;" @click="postThisDomain(domain, domain.id)" class="pull-right btn btn-primary btn-outline-primary">
                          <i class="ti-save"></i>
                        </a>
                      </td>
                      <td class="w50">
                        <div class="os-toggler-w" :class="(domain.default) ? 'on' : ''" @click="setDefault(domain)">
                          <div class="os-toggler-i">
                            <div class="os-toggler-pill"></div>
                          </div>
                        </div>
                      </td>
                      <td class="row-actions w50">
                        <a href="javascript:;" @click="removeThisDomain(domain.id)" class="danger has-tooltip text-danger" v-if="!domain.default">
                          <i class="dashicons dashicons-dismiss"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import domainList from '@/mixins/appmanager'

export default {
  name: 'domainst',
  mixins: [domainList],
  data () {
    return {
      domains: null,
      newDomain: {
        domain: '',
        app: this.app,
        default: false,
      }
    }
  },
  mounted () {
    this.fetchDomainList()
  },
  methods: {
    fetchDomainList(){
      this.fetchDomains(this.app).then(response => {

        this.domains = response.body;

      }, response => {
        // error callback
      })
    },
    removeThisDomain(id) {

      this.removeDomain(id).then(response => {

        this.fetchDomainList();

      }, response => {


      })
    },
    setDefault(data){
      data.default = (!data.default) ? true : false;

      this.postThisDomain(data, data.id);
    },
    postThisDomain(data, id = ''){

      this.postDomain(data, id).then(response => {

        this.fetchDomainList();

      }, response => {

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/configuration/domains.vue